const mediaItems = [
  {
    id: 1,
    title: '本周编辑精选：不可错过的五部韩漫新作',
    desc: '编辑团队从本周更新的数百部韩漫中挑选出五部最值得关注的新作。',
    author: '编辑 · 小雨',
    time: '2天前',
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20editorial%20illustration%20of%20five%20colorful%20manga%20panels%20arranged%20in%20a%20creative%20layout%2C%20warm%20artistic%20composition%20with%20Korean%20webtoon%20style%20elements%2C%20soft%20cream%20background%20with%20gentle%20gradients%2C%20no%20text&width=600&height=400&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '日漫经典回顾：《钢之炼金术师》为什么是神作',
    desc: '从角色塑造到世界观构建，全面解析这部不朽经典。',
    author: '编辑 · 阿树',
    time: '3天前',
    img: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20warm%20toned%20illustration%20of%20a%20classic%20manga%20reading%20scene%2C%20old%20books%20and%20soft%20lighting%2C%20artistic%20vintage%20editorial%20style%2C%20warm%20sepia%20and%20cream%20tones%2C%20no%20text&width=600&height=400&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '漫迷投稿：我的追漫十年，从纸质到屏幕',
    desc: '一位资深漫迷分享十年来追漫方式的变化与感悟。',
    author: '漫迷 · 小绿',
    time: '5天前',
    img: 'https://readdy.ai/api/search-image?query=A%20thoughtful%20illustration%20of%20transition%20from%20physical%20books%20to%20digital%20screens%2C%20books%20and%20mobile%20device%20side%20by%20side%2C%20warm%20minimalist%20composition%2C%20soft%20natural%20light%2C%20cream%20and%20warm%20gray%20tones%2C%20no%20text&width=600&height=400&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '漫画中的东方美学：从浮世绘到现代Webtoon',
    desc: '探索东方艺术传统如何在当代漫画中得到传承与创新。',
    author: '编辑 · 墨言',
    time: '1周前',
    img: 'https://readdy.ai/api/search-image?query=An%20artistic%20fusion%20illustration%20blending%20traditional%20Japanese%20ukiyo-e%20style%20with%20modern%20digital%20manga%20art%2C%20flowing%20lines%20and%20vibrant%20colors%2C%20elegant%20composition%2C%20warm%20cream%20and%20indigo%20tones%2C%20no%20text&width=600&height=400&seq=media-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">编辑精选</h2>
          <p className="mt-2 text-sm text-foreground-500">编辑团队与漫迷共创的优质内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {mediaItems.map((item) => (
            <a key={item.id} href="#cards" className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
              <div className="flex flex-col sm:flex-row">
                <div className="sm:w-48 flex-shrink-0 aspect-[3/2] sm:aspect-auto overflow-hidden">
                  <img src={item.img} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400" loading="lazy" />
                </div>
                <div className="flex-1 p-5 flex flex-col justify-center">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">{item.desc}</p>
                  <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                    <span className="whitespace-nowrap">{item.author}</span>
                    <span className="whitespace-nowrap">{item.time}</span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}